import {SET_ACCOUNT_DATA, SET_SHOW_ADDRESS_VALIDATION_MESSAGE, SET_ACCOUNT_MODE} from "../../actions/actionTypes";

export function accountReducer(state, action) {
    state = state || {};
    switch (action.type) {
        case SET_ACCOUNT_DATA:
            return Object.assign({}, state, {
                history: action.accountData.history
            });
        case SET_ACCOUNT_MODE:
            return Object.assign({}, state, {
                mode: action.mode,
                params: action.params
            });
        case SET_SHOW_ADDRESS_VALIDATION_MESSAGE:
            return Object.assign({}, state, {
                showAddressValidationMessage: action.showAddressValidationMessage
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/account/accountReducer.js